import { registerQuery } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import authHttpClient from 'hub-http/clients/apiClient';
import { getAccessControlsRpc } from 'automation-ui-management/__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: authHttpClient
});
export const GET_AI_SETTINGS_ACCESS = registerQuery({
  fieldName: 'aiSettingsAccess',
  fetcher() {
    return chirpClient.call(getAccessControlsRpc, {});
  }
});